import { firebaseConfig, VAPID } from "@3gaam/app/src/config";
import { store } from "@3gaam/app/src/store";
import {
  addMessageAction,
  registerNotificationTokenAction,
  updateMessageByIdAction,
} from "@3gaam/app/src/store/message";
import { handleFirebase } from "@3gaam/shared/utils/firebase";
import { MessagePayload } from "firebase/messaging";

let version = process.env.REACT_APP_VERSION;

export function createNotification(message: MessagePayload) {
  store.dispatch(addMessageAction({ ...message, showAsNotification: true }));

  setTimeout(() => {
    store.dispatch(
      updateMessageByIdAction({
        messageId: message.messageId,
        message: { showAsNotification: false },
      }),
    );
  }, 3000);

  navigator.serviceWorker
    .getRegistration("/firebase-cloud-messaging-push-scope")
    .then((registration) => {
      if (!registration) return;
      let url = message?.data?.["_Link"];
      const notificationOptions = {
        ...(message.notification || {}),
        tag: "notification",
        data: {
          url: url,
        },
      };
      registration.showNotification(
        message.notification?.title || "پیام جدید",
        notificationOptions,
      );
    });
}

export function createMessage(message: MessagePayload) {
  store.dispatch(addMessageAction({ ...message, showAsNotification: false }));
}

export function handleMessages() {
  if ("serviceWorker" in navigator) {
    const notificationData = store.getState().message.notification.registerInfo;

    const newMessageHandler = (firebaseMessage: MessagePayload) => {
      const isNotificationDisabled =
        store.getState().message.notification.disabled;

      if (!isNotificationDisabled) {
        createNotification(firebaseMessage);
      } else {
        createMessage(firebaseMessage);
      }
    };

    const shouldRefreshToken = () => {
      if (localStorage.getItem("ConsulteeId")) {
        return false;
      }
      if (!notificationData?.Timestamp) {
        return true;
      }

      const _MS_PER_DAY = 1000 * 60 * 60 * 24;

      const daysSinceLastRefresh =
        (new Date().getTime() -
          new Date(notificationData.Timestamp).getTime()) /
        _MS_PER_DAY;

      return daysSinceLastRefresh >= 30;
    };

    const changeKeyHandler = (curKey: string) => {
      const curClientId =
        store.getState().message.notification?.registerInfo?.ClientId;

      store
        .dispatch(
          registerNotificationTokenAction({
            CurrentClientId: curClientId || null,
            FcmToken: curKey,
            VersionName: version,
            ClientType: "APP",
          }),
        )
        .then((res) => {
          console.info(`fcm Token: ${curKey}`);
          console.info(` Token: `, res.payload);
        });
    };

    handleFirebase(
      changeKeyHandler,
      newMessageHandler,
      firebaseConfig,
      VAPID,
      shouldRefreshToken(),
    );
  }
}
